import { StateCreator } from "zustand";
import { FetchMonthlyVisitReportType } from "../../../domain/models/daily-visit-report/dailyVisitReport";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { FetchMonthlyVisitReport } from "../../../domain/useages/daily-visit-report/fetchMonthlyVisitReport";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { RemoteFetchMonthlyVisitReport } from "../../../data/usecases/daily-visit-report/remote-fetch-monthly-visit-report";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchMonthlyVisitReportInterface {
  FetchMonthlyVisitReport: FetchMonthlyVisitReportType;
  FetchMonthlyVisitReportState: FetchState;
  fetchMonthlyVisitReport: Function;
}

const initialStates = {
  FetchMonthlyVisitReport: {} as FetchMonthlyVisitReportType,
  FetchMonthlyVisitReportState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchMonthlyVisitReportSlice: StateCreator<
  FetchMonthlyVisitReportInterface
> = (set) => ({
  ...initialStates,
  fetchMonthlyVisitReport: async (
    month: number,
    year: number,
    params: FetchMonthlyVisitReport.Params
  ) => {
   const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
   const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchMonthlyVisitReport = new RemoteFetchMonthlyVisitReport(
      `${BASE_URL}${Endpoints.FETCH_MONTHLY_VISIT_REPORT}`,
      axiosHttpClient
    );

    set(() => ({ FetchMonthlyVisitReportState: FetchState.LOADING }));
    let result = await remoteFetchMonthlyVisitReport.fetch(month, year, params);
    return result;
  },
});
